import { rootRoute } from '@/ui/pages/root'
import { publicLayoutRoute } from '@/ui/pages/public'
import { indexRoute } from '@/ui/pages/index'
import { publicInvestigationsRoute } from '@/ui/pages/public/investigations/list/page'
import { publicInvestigationDetailRoute } from '@/ui/pages/public/investigations/detail/page'
import { publicLoginRoute } from '@/ui/pages/public/login/page'
import { publicRegisterRoute } from '@/ui/pages/public/register/page'
import { oauthCallbackRoute } from '@/ui/pages/public/oauth-callback/page'
import { publicInvestigatorsRoute } from '@/ui/pages/public/investigators/page'
import { publicAboutRoute } from '@/ui/pages/public/about/page'
import { mentionsLegalesRoute } from '@/ui/pages/public/legal/mentions-legales/page'
import { confidentialiteRoute } from '@/ui/pages/public/legal/confidentialite/page'
import { cookiesRoute } from '@/ui/pages/public/legal/cookies/page'
import { audioCreditsRoute } from '@/ui/pages/public/legal/credits-audio/page'
import { managementLayoutRoute, managementIndexRoute } from '@/ui/pages/management'
import { dashboardRoute } from '@/ui/pages/management/dashboard/page'
import { investigationsRoute } from '@/ui/pages/management/investigations'
import { commentsRoute } from '@/ui/pages/management/comments'
import { commentsIndexRoute } from '@/ui/pages/management/comments/list/page'
import { commentsModerationRoute } from '@/ui/pages/management/comments/moderation/page'
import { investigationsIndexRoute } from '@/ui/pages/management/investigations/list/page'
import { investigationsCreateRoute } from '@/ui/pages/management/investigations/create/page'
import { investigationsEditRoute } from '@/ui/pages/management/investigations/edit/page'
import { investigationsLeadsRoute } from '@/ui/pages/management/investigations/leads/page'
import { investigationsLeadDetailRoute } from '@/ui/pages/management/investigations/lead-detail/page'

import { categoriesRoute } from '@/ui/pages/management/categories/page'
import { investigatorsRoute } from '@/ui/pages/management/investigators/page'
import { translationsRoute } from '@/ui/pages/management/translations'
import { translationsDashboardRoute } from '@/ui/pages/management/translations/page'
import { translationsInvestigationDetailRoute } from '@/ui/pages/management/translations/investigation-detail/page'
import { translationsLeadDetailRoute } from '@/ui/pages/management/translations/lead-detail/page'
import { liveRoute } from '@/ui/pages/management/live/page'
import { settingsRoute } from '@/ui/pages/management/settings/page'
import { profileRoute } from '@/ui/pages/management/profile/page'
import { importExportRoute } from '@/ui/pages/management/import-export/page'

// Build the route tree
export const routeTree = rootRoute.addChildren([
  publicLayoutRoute.addChildren([
    indexRoute,
    publicInvestigationsRoute,
    publicInvestigationDetailRoute,
    publicInvestigatorsRoute,
    publicAboutRoute,
    mentionsLegalesRoute,
    confidentialiteRoute,
    cookiesRoute,
    audioCreditsRoute,
    publicLoginRoute,
    publicRegisterRoute,
    oauthCallbackRoute,
  ]),
  managementLayoutRoute.addChildren([
    managementIndexRoute,
    dashboardRoute,
    investigationsRoute.addChildren([
      investigationsIndexRoute,
      investigationsCreateRoute,
      investigationsEditRoute,
      investigationsLeadsRoute,
      investigationsLeadDetailRoute,
    ]),
    commentsRoute.addChildren([commentsIndexRoute, commentsModerationRoute]),
    liveRoute,
    settingsRoute,
    profileRoute,
    importExportRoute,
    categoriesRoute,
    investigatorsRoute,
    translationsRoute.addChildren([
      translationsDashboardRoute,
      translationsInvestigationDetailRoute,
      translationsLeadDetailRoute,
    ]),
  ]),
])
